/**
 * Routes where platform admins may keep "All Tenants" selected in the header
 * (cross-tenant aggregate views). Other routes auto-revert to home tenant.
 */
export const AGGREGATE_TENANT_ROUTES = [
  '/',
  '/models',
  '/models/group',
  '/tools',
  '/connections',
  '/agent-registry',
  '/ai-transparency',
  '/evals-simulations',
  '/monitoring',
  '/admin',
  '/projects',
  '/prompts',
  '/skills',
] as const

export function isAggregateTenantRoute(pathname: string): boolean {
  return (AGGREGATE_TENANT_ROUTES as readonly string[]).includes(pathname)
}
